import React, { useState, useEffect } from "react";
import { Clear, Clear_Large, SearchIcon } from "./ProjectIcons";
import { globalSearchClasses } from "./tailwindClassnames";

type GlobalSearchProps = {
    onChangeGlobalSearch: (value: string) => void
    savedString?: string
    placeholder?: string
    showClearButton?: boolean
    clearOnSearch?: boolean
}

const GlobalSearch = ({
    onChangeGlobalSearch,
    savedString,
    placeholder = "",
    showClearButton = true,
    clearOnSearch = false
}: GlobalSearchProps) => {
    const [subStr, setSubStr] = useState(savedString ? savedString : "");
    // useeffect to rerender the component when savedString changes
    useEffect(() => {
        setSubStr(savedString ? savedString : "");
    }, [savedString]);

    return (
        <div className={globalSearchClasses.container} data-testid='globalsearch'>
            <div className={globalSearchClasses.inputContainer}>
                <div className={globalSearchClasses.inputWrapper}>
                    <input
                        id="globalsearch"
                        data-testid='globalsearch-input'
                        placeholder={placeholder}
                        value={subStr}
                        className={globalSearchClasses.input}
                        onChange={(e) => setSubStr(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                onChangeGlobalSearch(subStr);
                                if (clearOnSearch) setSubStr('');
                            }
                        }}
                    />
                    {showClearButton && subStr && (
                        <button
                            className={globalSearchClasses.clearButton}
                            onClick={() => {
                                setSubStr('')
                                onChangeGlobalSearch('')
                            }}
                        >
                            <Clear_Large />
                        </button>
                    )}
                </div>
                <button className={globalSearchClasses.searchButton}
                    type="button"
                    data-testid='globalsearch-button'
                    onClick={() => {
                        onChangeGlobalSearch(subStr);
                        if (clearOnSearch) setSubStr('');
                    }}
                >
                    <SearchIcon />
                </button>
            </div>
        </div>
    )
};

export default GlobalSearch;